import { Link } from "react-router-dom";

import { Button } from "@/shared/foundation/primitives";
import { Goto } from "@/shared/navigation";

import styles from "./FullPageError.module.css";

export function UnauthorizedPage() {
  return (
    <div className={styles.container}>
      <p className={styles.heading}>401</p>
      <p className={styles.subheading}>Unauthorized</p>
      <p className={styles.description}>
        Sorry, you don&apos;t have permission to access this resource. If you
        believe this is an error, please contact{" "}
        <a href="mailto:support@roboto.ai">support@roboto.ai</a>.
      </p>
      <div className={styles.actions}>
        <Link to={Goto.route.Home} style={{ textDecoration: "none" }}>
          <Button variant="contained" color="secondary" size="large">
            Go to Homepage
          </Button>
        </Link>
      </div>
    </div>
  );
}
